import React from 'react';
import CheckoutStep from './CheckoutStep';


const CheckoutStepsList = ({ checkoutSteps }) => (
  <ul className="checkoutCoursier-recap-stepsList">
    {checkoutSteps.map((step, index) => {
      const { status, content, id } = step
      const isLastStep = index === checkoutSteps.length - 1
      return (
        <CheckoutStep statusClass={status} content={content} key={id} isLastStep={isLastStep} />
      )
    })}
  </ul>
);

export default CheckoutStepsList;



// WEBPACK FOOTER //
// ./src/components/buy/Checkout/CheckoutStepsList.js